import { purpurColorGray600, purpurColorGreen600, purpurColorOrange600, purpurColorRed600, } from '@purpurds/tokens/color/variables';
import DeviceStatus from '../../../constants/deviceStatus';
export const getDeviceStatusColor = (deviceStatus) => {
    switch (deviceStatus) {
        case DeviceStatus.OK:
            return purpurColorGreen600;
        case DeviceStatus.NEUTRAL:
            return purpurColorGray600;
        case DeviceStatus.WARN:
            return purpurColorOrange600;
        case DeviceStatus.ERROR:
            return purpurColorRed600;
        default:
            return purpurColorGray600;
    }
};
